export class  Local {

    code: string;
    creator_id: any;
    address: string;
    ubigeo_id: any;
    district: null;
    address_number: null;
    local_area: null;
    contact_name: string;
    contact_lastname: string;
    contact_email: string;
    contact_phone: string;
    owner_mass: {
        cellphone: string;
    };
    phone: any;
    latitud: number;
    longitud: number;
    flag_owner_place: any;
    owner_relationship: any;
    area_local_facade: any;
    monthly_rent: number;
    service_water: any;
    service_water_price: any;
    service_light: any;
    service_light_price: any;
    type_installation: any;
    voltage_type_installation: any;
    empty_local: any;
    plant_type_id: any;
    ruc: any;
    bank: Bank;
    bank_id: any;
    bank_account: any;
    score: any;
    status: string;
    created_at: any;
    updated_at: any;
    deleted_at: any;
    owner_leads: OwnerLeads[];
    attachments: Attachment[];
    ubigeo: Ubigeo;
    percentage: number;
    oferta: number;
    steps: Steps;
    step: number;
    term: any;


    constructor(local?){
        local = local || {};
        this.code = local.code || '';
        this.creator_id = local.creator_id || null;
        this.address = local.address || '';
        this.district = local.district || null;
        this.ubigeo_id = local.ubigeo_id || 0;
        this.address_number = local.address_number || null;
        this.local_area = local.local_area || null;
        this.contact_name = local.contact_name || null;
        this.contact_lastname = local.contact_lastname || '';
        this.contact_email = local.contact_email || '';
        this.contact_phone = local.contact_phone || '';
        this.owner_mass = local.owner_mass || null;

        this.phone  = local.phone || null;
        this.latitud = local.latitud || 0;
        this.longitud = local.longitud || 0;
        this.flag_owner_place  = local.flag_owner_place;
        this.owner_relationship  = local.owner_relationship || null;
        this.area_local_facade  = local.area_local_facade || null;
        this.monthly_rent  = local.monthly_rent || null;

        this.service_water = local.service_water || null;
        this.service_water_price = local.service_water_price || null;
        this.service_light = local.service_light || null;
        this.service_light_price = local.service_light_price || null;

        this.type_installation = local.type_installation || null;
        this.voltage_type_installation = local.voltage_type_installation || null;


        this.empty_local = local.empty_local;
        this.plant_type_id = local.plant_type_id;
        this.ruc = local.ruc || null;
        this.bank_id = local.bank_id || null;
        this.bank = local.bank || {};
        this.bank_account = local.bank_account || null;
        this.score = local.score || null;
        this.status = local.status || '';
        this.created_at = local.created_at || '';
        this.updated_at = local.created_at || '';
        this.deleted_at  = local.deleted_at || null;
        this.owner_leads = local.owner_leads || [];
        this.attachments = local.attachments || [];
        this.ubigeo = local.ubigeo || {};
        this.percentage = local.percentage || 0;
        this.oferta = local.oferta || '';
        this.steps = local.steps || {};
        this.step  = local.step || 0;
        this.term  = local.term || '';
    }
}


export interface  Ubigeo {
    id: any;
    name: string;
    show: boolean;
    in_range: boolean;
}

export interface  Bank {
    id: any;
    name: string;
}

export interface OwnerLeads{
    name: string;
    lastname: string;
    fiscal_address: string;
    email: string;
    phone: number;
    percentage_participation: number;
}

export interface Attachment{
    id: string | any;
    name: string;
    path: string;
    size: number;
    type: string;
}


export interface Steps {
    name: string;
    active: boolean;
    completed: boolean;
    index: number;
    step: string;
    id: any ;
}
